import FacilitiesList from "./FacilitiesList";
export default FacilitiesList;
